// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__VKhVV","animAlert":"styles_animAlert__jvXur","selection":"styles_selection__7Ho0n"};